<script setup lang="ts"></script>

<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Icon">
      <path
        id="Surface"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.0002 7C9.0002 5.34315 10.3433 4 12.0002 4C13.6571 4 15.0002 5.34315 15.0002 7C15.0002 8.65685 13.6571 10 12.0002 10C10.3433 10 9.0002 8.65685 9.0002 7ZM12.0002 2C9.23878 2 7.0002 4.23858 7.0002 7C7.0002 9.76142 9.23878 12 12.0002 12C14.7616 12 17.0002 9.76142 17.0002 7C17.0002 4.23858 14.7616 2 12.0002 2ZM4.44417 21.3303C5.52902 18.2296 8.50081 16 12.0003 16C15.4997 16 18.4715 18.2296 19.5564 21.3303C19.7388 21.8515 20.3092 22.1263 20.8305 21.9439C21.3518 21.7615 21.6266 21.191 21.4442 20.6697C20.0849 16.7847 16.3685 14 12.0003 14C7.63208 14 3.91569 16.7847 2.55638 20.6697C2.37399 21.191 2.64872 21.7615 3.17002 21.9439C3.69132 22.1263 4.26177 21.8515 4.44417 21.3303Z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>
